import { render, staticRenderFns } from "./distribution-sort.vue?vue&type=template&id=aa635064&"
import script from "./distribution-sort.vue?vue&type=script&lang=js&"
export * from "./distribution-sort.vue?vue&type=script&lang=js&"
import style0 from "./distribution-sort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports